import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { formatVal } from '../../../../helpers/value'
import { MAX_EXPORT_RESULT } from '../../common/constant'
import { Input } from '../../common/input'
import { selectTotalResult } from '../../selectCriteria/store/slice'
import {
  changeError,
  changeNumberOfCompany,
  selectError,
  selectNumberOfCompany,
} from '../store/slice'
import { ErrorMessage } from './../../common/errorMessage/index'
import classes from './index.module.scss'

export const ViewNumberOfCompany = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const totalResult = useSelector(selectTotalResult)
  const numberOfCompany = useSelector(selectNumberOfCompany)
  const isError = useSelector(selectError('numberOfCompanies'))

  const onChange = (count) => {
    if (count && count > 0) {
      dispatch(changeError({ key: 'numberOfCompanies', value: false }))
    }
    dispatch(changeNumberOfCompany(count))
  }

  const onBlur = () => {
    const maxResult = Math.min(totalResult, MAX_EXPORT_RESULT)
    if (numberOfCompany > maxResult) {
      dispatch(changeNumberOfCompany(maxResult))
    } else if (!numberOfCompany) {
      dispatch(changeNumberOfCompany(0))
    }
  }

  return (
    <>
      <Element className="dFlex gap1 alignItemsCenter">
        <Element>
          <Input
            isNumber
            value={numberOfCompany}
            onChange={onChange}
            onBlur={onBlur}
            wrapperClassname={classes.w96}
            wrapperStyle={{ backgroundColor: '#FFFFFF' }}
          />
        </Element>
        <Element>
          / {formatVal(totalResult, locale, false, 0)}{' '}
          <Translate
            value="screening.COUNT_RESULT"
            suffix={totalResult > 1 ? 's' : ''}
          />
        </Element>
      </Element>
      {isError && <ErrorMessage value="screening.NUMBER_OF_COMPANY_REQUIRED" />}
    </>
  )
}
